// Loading
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';


// WEBPACK FOOTER //
// ./src/actions/loading-actions.js